<template>
    <div class="coins" >
        <div class="coin" v-for="(b, i) in data" :key="i" >
            <div class="permissions v-m t-l" >
                <div class="loyalty" >
                    <div>
                        <img class="icon-loyalty v-m" :src="_global.assetsRoot + '/vip_img_bp.png'" />
                    </div>
                    <div class="segoe loyalty-points" >+{{ b.bp }}</div>
                </div>
            </div>
            <div class="rewards abs-center" >
                <div class="coin-icon reward-icon t-c" >
                    <img :src="_global.assetsRoot + `/common/coins_icon/web_phone_coins_0${6 - (data.length - 1 - i)}.png`" />
                </div>
            </div>
            <div class="reward-inf" >
                <div class="coin-count reward-count t-c" >
                    <span class="anton" >{{ fc(b.coins) }}</span>
                </div>
                <div class="price" >
                    <div class="btn price-btn t-c v-m" @click.stop="buy(b.hash, b.currency, b.price)" >
                        <span class="segoe" >R${{ b.price }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '../../utils/utils.js';
export default {
    props: {
        data: Array,
        extra: Object
    },
    data() {
        return {}
    },
    methods: {
        fc(currency) { return utils.fc(Math.round(currency * (1 + this.extra.coins))) },
        buy(hash, currency, price) {
            this.$emit('buy', { "hash": hash, "currency": currency, "price": price })
        }
    }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.coins {

    .coin {
        width: 320px;
        height: 260px;
        background: url($assetRoot + "/desktop/web_pc_coins_bg.png") bottom no-repeat;

        .permissions {
            .loyalty {
                margin-left: 12px;

                > div {
                    position: absolute;
                    top: 5%;
                }

                .icon-loyalty,
                .loyalty-points {
                    flex: 0 0 auto;
                }
            }
        }
    }
}

.mobile {
    .coins {
        .coin {
            background: url($assetRoot + "/common/coins_icon/web_phone_coins_bg.png") bottom no-repeat;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/coins.vue